import type { ProductConfig } from "../type";
import { validaInstrumentoConfig } from "../valida-instrumento";
import { QrCodeQueryLoading as ValidaInstrumentoQrCodeQueryLoading } from "../valida-instrumento/qr-code-query-loading";
import Logo from "./assets/Inmetro-Palma_da_Mao-Marca.png";
import LogoHeader from "./assets/Inmetro-Palma_da_Mao1.png";
import FavIcon from "./assets/inmetro_na_palma_da_mao_celular.png";

const QrCodeQueryLoading = () => (
	<ValidaInstrumentoQrCodeQueryLoading
		scannedImage={Logo}
		scannedImageAlt="Inmetro na Palma da Mão"
	/>
);

export const inmetroNaPalmaDaMaoConfig: ProductConfig = {
	...validaInstrumentoConfig,
	Logo: LogoHeader,
	FavIcon,
	QrCodeQueryLoading,
	product: {
		...validaInstrumentoConfig.product,
		name: "Inmetro Na Palma da Mão",
		domains: [
			"inmetro.validainstrumento.com.br",
			"www.inmetro.validainstrumento.com.br",
		],
		description: "Valide seus instrumentos de segurança em tempo real",
	},
};
